import { Cancel } from "@mui/icons-material";
import { IconButton, styled } from "@mui/material";
import clsx from "clsx";

const IconButtonStyled = styled(IconButton)({
  height: "1rem",
  width: "1rem",
  padding: 0,
  visibility: "hidden",
  "&.show": {
    visibility: "visible",
  },
});

const ClearInputUnstyled = ({ hasValue, onClear, className }) => {
  return (
    <IconButtonStyled
      onClick={onClear}
      size="small"
      className={clsx({ show: hasValue }, className)}
    >
      <Cancel sx={{ width: "100%", height: "100%" }} />
    </IconButtonStyled>
  );
};

const ClearInput = styled(ClearInputUnstyled)({});
export default ClearInput;
